angular.module('tf.controllers')

    .controller('AdminController', ['$scope', 'HttpService','NotificationService',
        function ($scope, HttpService, NotificationService){

            $scope.generateReferer = function(){
                HttpService.get('admin/generatereferer').then(function(res){
                    $scope.referer = res.data.link;
                });
            };

            $scope.migrateHistory = function(){
                if(window.confirm('You are about to migrate and the produce history to the statistics, are you sure?')){
                    HttpService.post('admin/stat/migrate', {}).then(function(){
                        alert('Done');
                    });
                }
            };

            $scope.generateTestStatistics = function(){
                if(!$scope.projectId || $scope.projectId === '' || !$scope.numOfStats || $scope.numOfStats === ''){
                    alert("Enter project ID and number of elements to create");
                } else {
                    HttpService.post('admin/stat/generate', {pid : $scope.projectId, num : $scope.numOfStats}).then(function(){
                        alert('Done');
                    });
                }
            };

            $scope.generateTestStatisticsForAllUserProjects = function(){
                HttpService.post('admin/stat/generateAll', {min : $scope.minNumOfStats, max : $scope.maxNumOfStats}).then(function(){
                    alert('Done');
                });
            };

            $scope.deleteAllTestStatistics = function(){
                if(window.confirm('Are you sure you want to delete all the test statistics for your projects')) {
                    HttpService.post('admin/stat/delete').then(function () {
                        alert('Done');
                    });
                }
            };


            $scope.credentials = {
                email: '',
                password: ''
            };

            $scope.openUserCreationPopup = function(){
                NotificationService.popup('create-user');
            };

            $scope.createUser = function(credentials){
                HttpService.post('admin/createuser',{credentials : credentials}).then(function(res){
                    alert(res.data.message);
                }, function(res){
                    alert(res.data.message);
                });
            };

            $scope.addFarmer = function(farmId){
                if(window.confirm('Add New Farmer?')) {
                    HttpService.post('farmer',{farm : farmId}).then(function(){
                        getFarmers();
                    });
                }
            };
            $scope.deleteFarmer = function(farmId, farmer){
                if(window.confirm('Delete farmer?')) {
                    HttpService.post('farmer/delete', {farm: farmId, farmer: farmer}).then(function () {
                        getFarmers();
                    });
                }
            };


            function getFarmers(){
                HttpService.get('farm').then(function(res){
                    $scope.farms = res.data;
                });
            }

            $scope.addCollaborators = function(farmId){
                HttpService.post('farm/' + farmId + '/collaborators', $scope.shareEmails).then(function(res){
                    getFarmers();
                });
            };

            $scope.shareEmails = {
                emails : [],
                available : [],
                role : 'user'
            };
            getFarmers();

        }]);